export default {"src":"/_next/static/media/netopia.0bbcf2e4.svg","height":75,"width":418,"blurWidth":0,"blurHeight":0};